var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007BB3",
    d: "M8 0a7.847 7.847 0 0 0-8 7.683C0 13.023 5.494 20 8 20s8-6.977 8-12.317A7.847 7.847 0 0 0 8 0m0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
  })));
};
export default SvgLocation;